export default __webpack_public_path__ + "static/blo3-bcbc5a7d195230c42491b5e936ed807f.jpg";